module.exports = ".fa-lg {\n  font-size: 1.33333333em;\n  line-height: 1em;\n  vertical-align: -15%;\n  padding: 8px; }\n\n.card-content-block {\n  margin: p;\n    margin-margin: 0;\n    margin-padding: 0 0 1em; }\n\ntr.td-data-table-row {\n  height: 140px; }\n\n.HandCursor {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/documentos/documentos.component.scss
// module id = ./src/app/consulta/documentos/documentos.component.scss
// module chunks = main